var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 13.8333H2.16667V2.16667H13.8333M13.8333 0.5H2.16667C1.72464 0.5 1.30072 0.675595 0.988155 0.988155C0.675595 1.30072 0.5 1.72464 0.5 2.16667V13.8333C0.5 14.2754 0.675595 14.6993 0.988155 15.0118C1.30072 15.3244 1.72464 15.5 2.16667 15.5H13.8333C14.2754 15.5 14.6993 15.3244 15.0118 15.0118C15.3244 14.6993 15.5 14.2754 15.5 13.8333V2.16667C15.5 1.72464 15.3244 1.30072 15.0118 0.988155C14.6993 0.675595 14.2754 0.5 13.8333 0.5ZM11.75 11.5417C11.75 10.2917 9.25 9.66667 8 9.66667C6.75 9.66667 4.25 10.2917 4.25 11.5417V12.1667H11.75M8 8.20833C8.49728 8.20833 8.97419 8.01079 9.32582 7.65916C9.67746 7.30753 9.875 6.83061 9.875 6.33333C9.875 5.83605 9.67746 5.35914 9.32582 5.00751C8.97419 4.65588 8.49728 4.45833 8 4.45833C7.50272 4.45833 7.02581 4.65588 6.67417 5.00751C6.32254 5.35914 6.125 5.83605 6.125 6.33333C6.125 6.83061 6.32254 7.30753 6.67417 7.65916C7.02581 8.01079 7.50272 8.20833 8 8.20833Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClient);
export default __webpack_public_path__ + "static/media/userClient.66178b457b3b1bae5dbbf6efe4663b67.svg";
export { ForwardRef as ReactComponent };